import { APIError } from "@/adapters/api";

const REASON_MESSAGES: Record<string, string> = {
	"invite-already-exists": "Já existe um convite pendente para este e-mail.",
	"already-member": "Esta pessoa já faz parte deste canteiro.",
	"already-account-member": "Esta pessoa já faz parte da organização.",
	"worker-already-linked":
		"Essa pessoa já está vinculada a um usuário neste canteiro.",
};

const WORKER_LINKED_MESSAGE = REASON_MESSAGES["worker-already-linked"] ?? "";

export function inviteErrorMessage(err: unknown, fallback: string): string {
	if (err instanceof APIError) {
		if (err.violations.worker === "already_linked") {
			return WORKER_LINKED_MESSAGE;
		}
		return REASON_MESSAGES[err.reason] || err.message || fallback;
	}
	return err instanceof Error && err.message ? err.message : fallback;
}
